import { writable } from 'svelte/store';
export let nachrichten;
if (typeof window !== 'undefined') {
    nachrichten = writable(JSON.parse(localStorage.getItem('nachrichten')) || []);
    nachrichten.subscribe((value) => (localStorage.nachrichten = value ? JSON.stringify(value) : JSON.stringify([])));
}
export let playGong;
playGong = writable(true);
